<template>
  <div>
    <button
      class="button md:md-button"
      @click='onClick'
      v-bind:disabled=disabled
      v-bind:class="{ 'top-margin md:md-top-margin': !noMargin }"
    >
      {{text}}
    </button>
  </div>
</template>

<script>
export default {
  name: 'Button',
  props: {
    text: String,
    onClick: Function,
    disabled: Boolean,
    noMargin: Boolean,
  },
};
</script>

<style>
.button {
  background-color: #5e5b5c;
  border-radius: 5rem;
  color: #fff;
  font-size: 1rem;
  padding: .25em 1.75em;
}

.top-margin {
  margin-top: 0;
  /* margin-top: 2.75em; */
}

@responsive {
  .md-button {
    font-size: 18.5pt;
  }

  .md-top-margin {
    margin-top: 0;
    /* margin-top: calc(2.75em); */
  }
}
</style>
